import { UseFormReturn } from 'react-hook-form'
import { InputFormValues } from '@/modules/CombinedLogs/types'
import { TableFormTimeInput } from './TableFormTimeInput'
import styles from './TimeInputContainer.module.scss'
import { useNightShiftInfo } from '@/modules/Auth'
import { SuggestionInputTable } from '@/ui/SuggestionInputTable'
import { isValidDateFormat } from '@/helpers/isValidTimeFormat'
import { useCombinedLogsTableFormStateStore } from '@/modules/CombinedLogs/store'

export const TimeInputContainer = ({
    form,
    dayOptions,
}: {
    form: UseFormReturn<InputFormValues>
    dayOptions: Array<{ id: string; label: string; value: string }>
}) => {
    const { isNightShift, isAfterMidnight } = useNightShiftInfo()
    const { setNightShiftDate } = useCombinedLogsTableFormStateStore()

    const handleChangeNightShiftDate = (value: string) => {
        if (!isValidDateFormat(value)) {
            setNightShiftDate(null)
        } else {
            setNightShiftDate(value)
        }
        form.setValue('nightShiftDate', value)
    }

    return (
        <div className={styles.timeInputContainer}>
            <TableFormTimeInput form={form} />
            {isNightShift && isAfterMidnight() && (
                <SuggestionInputTable
                    options={dayOptions}
                    isNoFiltering
                    variant="table"
                    transparent
                    fullWidth
                    className={styles.daySuggestionMenu}
                    inputClassName={styles.dayInput}
                    placeholder="Day"
                    value={form.watch('nightShiftDate') ?? ''}
                    onChange={handleChangeNightShiftDate}
                />
            )}
        </div>
    )
}
